import { useI18n } from '../i18n.client'
import { Image } from '@shopify/hydrogen'
import styles from '../../assets/scss/components/products/product-not-found.module.scss'

export const NotFound: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [i18n] = useI18n()

  return (
    <div className={styles.notFound}>
      <div className={styles.topSection}>
        <Image
          alt={i18n.translate('out-of-stock-title')}
          height={433}
          src="/out-of-stock.svg"
          width={146}
        />
        <div className={styles.description}>
          {i18n.translate('out-of-stock-description')}
        </div>
        <a className={styles.paginationButton} href="/collections/lockets">
          {i18n.translate('see-all-lockets')}
        </a>
      </div>
      <div className={styles.swiperWrapper}>
        {children}
      </div>
    </div>
  )
}
